import { render, staticRenderFns } from "./RptVolumeAndActivity.vue?vue&type=template&id=5236e824&scoped=true&"
import script from "./RptVolumeAndActivity.vue?vue&type=script&lang=js&"
export * from "./RptVolumeAndActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236e824",
  null
  
)

export default component.exports